import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Unsubscribable } from '@ats/utility';
import { takeUntil } from 'rxjs/operators';
import { CmTableService, SELECT_COLUMN_NAME } from '../../services/table.service';

@Component({
    selector: 'cm-table-selected-filter',
    templateUrl: './table-selected-filter.component.html',
    styleUrls: ['./table-selected-filter.component.scss'],
    standalone: false
})
export class CmTableSelectedFilterComponent extends Unsubscribable implements OnInit {
	form: UntypedFormGroup;
	selectionField = SELECT_COLUMN_NAME;

	constructor(private waiter: CmTableService, private fb: UntypedFormBuilder) {
		super();
	}

	ngOnInit() {
		this.form = this.fb.group({
			filter: null,
		});

		this.form
			.get('filter')
			.valueChanges.pipe(takeUntil(this.unsub))
			.subscribe((value: boolean | null) => this.waiter.updateSelectionFilter(value));
	}
}
